// sagas.js
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from "../actions/visitorTypeTypes";
import * as actions from "../actions/visitorTypeActions.js";
import axiosInstance from '../../interceptor/interceptor.js';  


// Worker Saga: Will fetch vistor types from API
function* fetchVisitorTypesSaga() {
    try {
        const response = yield call(axiosInstance.get, '/visitor-type/list');
        ////console.log(response.data);
        yield put(actions.fetchVisitorTypesSuccess(response.data.visitorTypes));
    } catch (error) {
        yield put(actions.fetchVisitorTypesFailure(error.message));
    }
}

// function* addVisitorTypesSaga(action) {
  
//     try {
//         // Make the API call to add the visitors
//         const payload = {
//             name: action.payload
//         }
//         const response = yield call(axiosInstance.post, 'visitor-type/create', payload);
       
//         //console.log("responseof", response);
//         if (response.data) {
          
//             // Dispatch a success action (you can add a success message or other needed data)
//             yield put(actions.addVisitorTypesSuccess());

//             // Trigger fetching of the visitors list after successfully adding the visitors
//             yield put(actions.fetchVisitorTypesRequest());
//         } else {
//             // If something goes wrong, we can handle failure
//             yield put(actions.addVisitorTypesFailure('Failed to add the visitors'));
//         }
//     } catch (error) {
//         // Log the error and dispatch failure action
//         //console.error('Error while adding visitors:', error);
//         const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
//         //console.error('Error while adding visitor type:', errorMessage);

//         yield put(actions.addVisitorTypesFailure(errorMessage));
//     }
// }



function* addVisitorTypesSaga(action) {
  try {
    const payload = { name: action.payload };
    const response = yield call(axiosInstance.post, 'visitor-type/create', payload);

    //console.log(response);

    //console.log("saga1", response);

    // Check if the response indicates success
    if (response.data?.isSuccessful) {
      //console.log("saga2", response.data);
      // If successful, dispatch success actions
      yield put(actions.addVisitorTypesSuccess());
      // yield put(actions.fetchVisitorTypesRequest());
    } else {
      //console.log("saga3", response.data);
      // If the backend returns failure with a message (e.g., visitor type already exists)
      const errorMessage = response.data?.message || 'Failed to add visitor type.';
      yield put(actions.addVisitorTypesFailure(errorMessage));
    }
  } catch (error) {
    //console.error('Error while adding visitor type:', error);
    // Handle other errors (e.g., network error, server error)
    const errorMessage = error?.response?.data?.message || error.message || 'An unexpected error occurred.';
    yield put(actions.addVisitorTypesFailure(errorMessage));
  }
}




//for updating visitor types
function* updateVisitorTypesSaga(action) {
    try {
     ////console.log('saga')
     ////console.log(action.payload)
  //    ////console.log(id)
  const payload = { name: action.payload.visitortype }
      const response = yield call(axiosInstance.patch, `/visitor-type/update/${action.payload.id}`, payload );
  
      // //console.log('Updated visitor type:', response.data);
      // //console.log('Visitor Type ID:', action.payload.id);
      if(response.data.isSuccessful){
        yield put(actions.updateVisitorTypesSuccess (action.payload));
      }
    } catch (error) {
        // //console.log(error.response);
        yield put(actions.updateVisitorTypesFailure(error.response.data.message));
    }
  }

   //FOR DELETE VISITOR TYPES
function* deleteVisitorTypesSaga(action) {
    try {
      ////console.log(action.payload);
    const response = yield call(axiosInstance.patch, `/visitor-type/delete/${action.payload.id}`);
    ////console.log(response);
    ////console.log(response.data);
    
      // Check the response data to determine if the deletion was successful
      if (response.data) {
        // If the response indicates success, dispatch the success action
        yield put(actions.deleteVisitorTypesSuccess(action.payload.id)); 
        ////console.log("Deleted visitor type ID:", action.payload.id);
      } else {
        // If the deletion was not successful, dispatch failure with the error message
        yield put(actions.deleteVisitorTypesFailure('Failed to delete site'));
      }
    } catch (error) {
      // Handle any errors (e.g., network errors)
      yield put(actions.deleteVisitorTypesFailure(error.message)); // Pass the error message to failure action
    }
  }
  



// Watch for the FETCH_VISITOR_TYPES_REQUEST action and trigger the fetchVisitorTypesSaga
export default function* watchFetchData() {
    yield takeLatest(types.FETCH_VISITOR_TYPES_REQUEST, fetchVisitorTypesSaga);
    yield takeLatest(types.ADD_VISITOR_TYPES_REQUEST, addVisitorTypesSaga);
    yield takeLatest(types.UPDATE_VISITOR_TYPES_REQUEST, updateVisitorTypesSaga);
    yield takeLatest(types.DELETE_VISITOR_TYPES_REQUEST, deleteVisitorTypesSaga);
}

